import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { OrderPriceDisplay } from 'shared/ui/OrderPriceDisplay/OrderPriceDisplay';
import { DynamicTooltip } from 'shared/ui/Tooltip';

import type { Order } from 'entities/Order/model/types/OrderSchema';

export interface OrderSavingsProps {
    totalSavings: number;
    itemsCount: number;
    order: Order | null;
    orderHasLoadingPrices?: boolean;
}

export function OrderSavings({
    totalSavings,
    itemsCount,
    order,
    orderHasLoadingPrices,
}: Readonly<OrderSavingsProps>) {
    const { t } = useTranslation();

    if (itemsCount === 0 || totalSavings <= 0) return null;

    return (
        <Box
            data-testid="order_savings_section"
            sx={{
                marginTop: '8px',
                padding: '10px',
                borderRadius: '4px',
                backgroundColor: 'rgba(44, 179, 83, 0.1)',
                border: '1px solid #2CB353',
            }}
        >
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <Box display="flex" alignItems="center" gap={1}>
                    <Typography
                        sx={{ color: '#000', fontSize: '13px' }}
                        typography="openSans.body2"
                        data-testclass="label"
                    >
                        {t('Savings')}
                    </Typography>
                    <DynamicTooltip
                        content={t('Order savings tooltip')}
                        maxWidth={320}
                        containerStyle={
                            {
                                display: 'flex',
                            } as React.CSSProperties
                        }
                    >
                        <InfoOutlinedIcon
                            sx={{
                                fontSize: 14,
                                color: '#999999',
                            }}
                            aria-label={String(t('Order savings tooltip'))}
                        />
                    </DynamicTooltip>
                </Box>
                <OrderPriceDisplay
                    width="70px"
                    testClass="value"
                    typography="openSans.body2"
                    containerProps={{
                        fontWeight: 600,
                        color: '#2CB353',
                    }}
                    price={totalSavings}
                    order={order}
                    orderHasLoadingPrices={orderHasLoadingPrices}
                />
            </Box>
        </Box>
    );
}
